    export const handleChange = (e, func, ref) => {
    
        // Clear any existing timeout
        if (ref.current) {
          clearTimeout(ref.current);
        }

        // Set a new timeout
        ref.current = setTimeout(() => {
          func(e.target.value); // Update debounced value after delay
          // This is where you would trigger your API call or expensive operation
        }, 500); // 500ms delay
    };